module.exports = __webpack_public_path__ + "static/media/social_STAKE.4f70a6ec.jpg";